module.exports = __webpack_public_path__ + "img/mt.cfc5f79e.svg";